import { render } from "./MakePredictionsCricket.vue?vue&type=template&id=05ab7d62&scoped=true"
import script from "./MakePredictionsCricket.vue?vue&type=script&lang=js"
export * from "./MakePredictionsCricket.vue?vue&type=script&lang=js"

import "./MakePredictionsCricket.vue?vue&type=style&index=0&id=05ab7d62&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ab7d62"]])

export default __exports__